<template>
  <div id="contact" class="container section scrollspy section-padding">
    <div class="contact-header center-align">
      <h3 class="title-contact">Contacto</h3>
      <div class="divider-center"></div>
      <h5 class="subtitle-contact">
        ¿Tienes un proyecto en mente o una propuesta de colaboración? <br>
        <strong>¡Hablemos y hagámoslo realidad!</strong>
      </h5>
    </div>

    <div class="row contact-grid">
      <div
        class="col l4 m6 s12 contact-item-container"
        v-for="(redSocial, index) in redesSociales"
        :key="index"
      >
        <a class="contact-card z-depth-1 hoverable" :href="redSocial.link" target="_blank">
          <div class="icon-bg">
            <img
              class="responsive-img contact-icon"
              :src="redSocial.asset"
              :alt="redSocial.titulo"
            />
          </div>
          <div class="contact-info">
            <span class="contact-label">{{ redSocial.etiqueta }}</span>
            <h6 class="contact-title">{{ redSocial.titulo }}</h6>
          </div>
        </a>
      </div>
    </div>

    <div class="center-align footer-text">
      <p>© {{ new Date().getFullYear() }} — Diseñado y desarrollado por Cristhian Vera Almeida</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      redesSociales: [
        {
          etiqueta: "LinkedIn",
          titulo: "Conectemos en profesional",
          asset: "/./img/icons/linkedin.svg",
          link: "https://www.linkedin.com/in/cristhianveal/",
        },
        {
          etiqueta: "Email",
          titulo: "developer@cristhianveal.dev",
          asset: "/./img/icons/gmail.svg",
          link: "mailto:developer@cristhianveal.dev",
        },
        
        {
          etiqueta: "GitHub",
          titulo: "Mira mi código",
          asset: "/./img/icons/github.svg",
          link: "https://github.com/Cristhianveal",
        },
        {
          etiqueta: "WhatsApp",
          titulo: "+593 97 863 0130",
          asset: "/./img/icons/whatsapp.svg",
          link: "https://wa.me/593978630130",
        },
        
       
        
      ],
    };
  },
};
</script>

<style scoped>
.section-padding { padding: 5rem 0; }

.title-contact {
  color: var(--colorSecundario);
  font-weight: 800;
  font-size: 3rem;
  margin: 0;
  text-transform: uppercase;
}

.divider-center {
  height: 5px;
  width: 80px;
  background-color: var(--colorPrincipal);
  margin: 15px auto 25px;
  border-radius: 10px;
}

.subtitle-contact {
  color: #616161;
  font-size: 1.3rem;
  margin-bottom: 50px;
  line-height: 1.5;
}

/* Grid de Contacto */
.contact-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.contact-item-container {
  padding: 15px !important;
}

.contact-card {
  display: flex;
  align-items: center;
  background: #ffffff;
  padding: 20px;
  border-radius: 15px;
  transition: all 0.3s ease;
  text-decoration: none;
  border: 1px solid rgba(0,0,0,0.05);
  height: 100%;
}

.contact-card:hover {
  transform: translateY(-5px);
  background: var(--colorPrincipal);
}

/* Al hacer hover, el texto cambia de color para legibilidad si el fondo es amarillo */
.contact-card:hover .contact-title,
.contact-card:hover .contact-label {
  color: var(--colorSecundario) !important;
}

.icon-bg {
  background: #f5f5f5;
  padding: 12px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  transition: background 0.3s ease;
}

.contact-card:hover .icon-bg {
  background: rgba(255, 255, 255, 0.5);
}

.contact-icon {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

.contact-info {
  display: flex;
  flex-direction: column;
}

.contact-label {
  font-size: 0.8rem;
  text-transform: uppercase;
  font-weight: 700;
  color: #9e9e9e;
  letter-spacing: 1px;
}

.contact-title {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: var(--colorSecundario);
  word-break: break-all; /* Para correos largos en móvil */
}

.footer-text {
  margin-top: 60px;
  color: #bdbdbd;
  font-size: 0.9rem;
}

@media only screen and (max-width: 600px) {
  .title-contact { font-size: 2.5rem; }
  .contact-card { padding: 15px; }
}
</style>